import { Validator } from "../Validator"
import ColorInput from "../Helpers/ColorInput.svelte"

export default class ColorValidator extends Validator {
    inputHelper = ColorInput

    constructor() {
        super("color", "Shows a color picker")
    }
}
